import { render, staticRenderFns } from "./Harjoitussuunnitelmat.vue?vue&type=template&id=19a1712e"
import script from "./Harjoitussuunnitelmat.vue?vue&type=script&lang=js"
export * from "./Harjoitussuunnitelmat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports